module.exports = __webpack_public_path__ + "img/9788936456832.9db66a34.jpg";